import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { AdvisoryModel } from '../../../../../core';

@JsonConverter
export class AdvisoryModelAdapter implements JsonCustomConvert<AdvisoryModel | undefined> {
    serialize(model: AdvisoryModel): any | undefined {
        return model ? String(model) : undefined;
    }

    deserialize(type: any): AdvisoryModel | undefined {
        switch (type) {
            case 'A':
                return AdvisoryModel.A;
            case 'G':
                return AdvisoryModel.G;
            case 'P':
                return AdvisoryModel.P;
            default:
                return AdvisoryModel.C;
        }
    }
}
